import { t } from 'src/i18n';
import type { ComputerViewModelExtended } from './computer-view-model-extended';
import { rulesForComputers } from './rules-for-computers';
import { computerHasMedicalData } from './computer-has-medical-data';

export function alertsForComputer(c: ComputerViewModelExtended): string[] {
  const warnings: string[] = [];

  rulesForComputers.forEach((r) => {
    if (r.test(c)) {
      warnings.push(r.message());
    }
  });

  if (c.unitType === 'computer' || c.unitType === '') {
    if (c.hasMedicalData) {
      if (c.type !== 'mobile' && c.elevated === false) {
        warnings.push(t('computers.alertMachineNotOnFloor'));
      }
      if (c.type !== 'mobile' && c.type !== 'Server' && c.computerIsInNetworkWithServer) {
        warnings.push(t('computers.alertPatientDataOnServer'));
      }
      if (c.type !== 'mobile' && c.locked === false) {
        warnings.push(t('computers.alertMachineLockedStorage'));
      }
      if (c.restrictedPhysicalAccess === false) {
        warnings.push(t('computers.alertRestrictedAccess'));
      }
    }
    if (c.computerIsInNetworkWithMedicalData) {
      if (!c.antiVirusRequirements) {
        c.antiVirusRequirements = [];
      }
      if (c.antiVirusRequirements.length < 3) {
        warnings.push(t('computers.alertAntiVirusRequirementsNotMet'));
      }
      if (c.type === 'Arbeidsstasjon' && c.displayPositionSecure === false) {
        warnings.push(t('computers.alertScreensPlacement'));
      }
    }
    if (c.computerIsInNetworkWithPersonalData) {
      if (c.systemUpdateOperatorType === 'NONE' || c.systemUpdateOperatorType === 'UNDEFINED') {
        warnings.push(t('computers.alertSystemUpdateOperationUndefined'));
      }
      if (
        (c.systemUpdateOperatorType === 'external' || c.systemUpdateOperatorType === 'internalAndExternal') &&
        (c.systemUpdateOperator === undefined || c.systemUpdateOperator === '')
      ) {
        warnings.push(t('computers.alertSystemUpdateSupplierUndefined'));
      }
      if (c.antiVirusOperatorType === 'NONE' || c.antiVirusOperatorType === 'UNDEFINED') {
        warnings.push(t('computers.alertAntiVirusOperationUndefined'));
      }
      if (
        (c.antiVirusOperatorType === 'external' || c.antiVirusOperatorType === 'internalAndExternal') &&
        (c.antiVirusOperator === undefined || c.antiVirusOperator === '')
      ) {
        warnings.push(t('computers.alertAntiVirusSupplierUndefined'));
      }
      if (c.type !== 'mobile' && (c.location === undefined || c.location === '')) {
        warnings.push(t('computers.alertPhysicalLocationUndefined'));
      }
    }
  }
  if ((c.unitType === 'remoteServer' || c.unitType === 'cloudService') && computerHasMedicalData(c)) {
    if (c.connectionType !== 'NHN' && c.connectionType !== 'NHNotherISP') {
      if (c.unitType === 'remoteServer') {
        // warnings.push('Fjernservere som behandler helseopplysninger skal være tilkoblet gjennom Norsk helsenett');
      }
      if (c.unitType === 'cloudService') {
        // warnings.push('Skytjenester som behandler helseopplysninger skal være tilkoblet gjennom Norsk helsenett');
      }
    }
    if (!c.serviceProviderContract) {
      warnings.push(t('computers.alertMissingDataProcessorAgreement'));
    }
  }
  if (c.unitType === 'printer' && c.computerIsInNetworkWithMedicalData) {
    if (!c.location) {
      warnings.push(t('computers.alertLocationNotSpecified'));
    }
    if (!c.printerPositionSecure) {
      warnings.push(t('computers.alertNetworkPrinterPlacement'));
    }
  }
  return warnings;
}
